import React from 'react'
import classes from './styles.module.scss';
import { useTranslation } from 'react-i18next';
import Card from '../../../../components/card/card.component';
import { useShared } from '../../../../contexts/shared.context';
import { ICardName, KatoType, SerSubtype } from '../../../../types/kato.types';
import { useKato } from '../../../../contexts/kato.context';
import { SERSubTypeToIcon } from '../../../../consts/other.conts';
import { useNavigate, useParams } from 'react-router-dom';

const currentMonth = new Date().getMonth() + 1;
const tableHeaders = ['', 'ifo', 'tenge'];
const translationKey = 'cards.ser-card'

const SerCard = () => {
    const { t } = useTranslation();
    const { setFullscreen } = useShared();
    const { basicStats } = useKato().katoGeneralInfo;
    const { currentLevel } = useKato();
    const navigate = useNavigate();
    const unit = currentLevel === KatoType.OBLAST ? t('billion') : t('million');
    const { kato, link, tab } = useParams<{ kato: string, link: string, tab: string }>();

    if (!basicStats) return null;
    const data = basicStats.filter(item => item.type === 'SER').sort((a, b) => +b.currentYearVal - +a.currentYearVal).slice(0, 4);
    if (data.length === 0) return null;

    const onClick = () => {
        setFullscreen({ open: true, type: ICardName.SER });
        navigate(`/${kato}/${link}/${tab}/${ICardName.SER}`);
    }

    return (
        <Card
            title={t(`${translationKey}.title`)}
            onClick={onClick}
            subtitle={t(`${translationKey}.subtitle`, { month: currentMonth })}
        >
            <div className={classes['ser-card']}>
                <table>
                    <thead>
                        <tr>
                            {
                                tableHeaders.map((header, index) => (
                                    <th key={index} className={classes['ser-card__header']}>
                                        <span>
                                            {header ? t(`${translationKey}.${header}`, { unit }) : ''}

                                        </span>
                                    </th>
                                ))
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.map((item) => (
                                <tr key={item.subType} >
                                    <td>
                                        <div className={classes['ser-card__item']}>
                                            <div className={classes['ser-card__icon']}>{SERSubTypeToIcon[item.subType as SerSubtype]}</div>
                                            <span className={classes['ser-card__title']}>{t(`${translationKey}.${item.subType}`)}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <span
                                            style={{ color: +item.ifo < 0 ? 'var(--color-failure)' : 'var(--color-success)' }}
                                            className={classes['ser-card__ifo']}>
                                            {item.ifo?.toString().replace('.', ',') ?? '0.0'}%
                                        </span>
                                    </td>
                                    <td>
                                        <span className={classes['ser-card__value']}>{item.currentYearVal?.toLocaleString().replace('.', ',') ?? 0}</span>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>

        </Card>
    )
}

export default SerCard